import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.goodreads.com/book/show/54898389-the-almanack-of-naval-ravikant"
        }}>{`The Almanack of Naval Ravikant`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.goodreads.com/book/show/35957157-thinking-in-bets"
        }}>{`Thinking in Bets by Annie Duke`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.goodreads.com/book/show/25614523-originals"
        }}>{`Originals by Adam Grant`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.goodreads.com/book/show/29093292-the-daily-stoic"
        }}>{`The Daily Stoic by Ryan Holiday`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.masterclass.com/classes/malcolm-gladwell-teaches-writing"
        }}>{`Malcolm Gladwell Teaches Writing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.coursera.org/learn/learning-how-to-learn"
        }}>{`Learning How to Learn`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      